/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_NoneInputs */

const cs_calendar_sync_none = /** @type {(inputs: Calendar_Sync_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tomto pohledu nejsou úkoly k synchronizaci`)
};

const en_calendar_sync_none = /** @type {(inputs: Calendar_Sync_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks in this view to sync`)
};

/**
* | output |
* | --- |
* | "No tasks in this view to sync" |
*
* @param {Calendar_Sync_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_none = /** @type {((inputs?: Calendar_Sync_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_none(inputs)
	return cs_calendar_sync_none(inputs)
});